import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Modal, Row, Collapse } from 'antd';
import { useState, useRef, useEffect } from 'react';
import { MyText } from '../../../components/common';
import { AudioPlayIcon, AudioPauseIcon, AudioIcon, SpeakerIcon } from '../../../assets';
import { PageName, ThemeCollapse, StyledButton } from './style';
import { useTranslation } from "react-i18next";
import { fetchArticleList, fetchAutorsList } from '../../../api'; 
import { fetchArticleListAction, fetchAutorsListAction, fetchCardsListAction } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";

interface ThemesModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  themes: any;
  onDataSubmit: (articles: any[], totalCount: number) => void;
  selectedSubThemeId: number | null;
  setSelectedSubThemeId: (id: number | null) => void;
  isCards?: any;
}

export const ThemesModal: React.FC<ThemesModalProps> = ({ visible, onOk, onCancel, themes, onDataSubmit,selectedSubThemeId, setSelectedSubThemeId, isCards }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  // const [selectedSubThemeId, setSelectedSubThemeId] = useState(null);
  const [authors, setAuthors] = useState([]);
  const [articles, setArticles] = useState([]);
  const audioRefs = useRef<HTMLAudioElement[]>([]);
  const segmentedParams: any = searchParams.get('type');
  const { Panel } = Collapse;
  const dispatch = useDispatch();
  const articleList = useSelector((state: any) => state.articles.articleList);
  const autorsList = useSelector((state: any) => state.articles.autorsList);
  const [pendingClose, setPendingClose] = useState(false);

  const {t, i18n} = useTranslation("common")

 const parentThemes = isCards ? themes : themes.filter(theme => theme.parent_id === 0);

  
  const handlePanelChange = (key) => {
    setActiveKeyTheme(activeKeyTheme === key ? null : key);
};

  useEffect(() => {
    if (!autorsList.success || !autorsList.data || !pendingClose) return;
    setAuthors(autorsList.data);
    onDataSubmit(autorsList.data || []);
    handleClose();
    setPendingClose(false);
  }, [autorsList.success, autorsList.data, pendingClose]);

  useEffect(() => {
    if (!articleList.success || !articleList.data || !pendingClose) return;
    setArticles(articleList.data.list || []);
    onDataSubmit(articleList.data.list || [], articleList.data.total_count || 0);
    handleClose();
    setPendingClose(false);
  }, [articleList.success, articleList.data, pendingClose]);

  
  const handleClose = () => {
    onCancel();
  };

  return (
    <Modal
      open={visible}
      onOk={() => {
        onOk();
      }}
      onCancel={handleClose}
      footer={null}
      centered
      width={380}
    >
      <Row style={{ marginBottom: '24px' }}>
        <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
        {t("topics")}
        </MyText>
      </Row>

            <PageName style={{ width: '100%' }}>
                 {[{ id: null, name: t("all") }, ...parentThemes].map(parentTheme => {
                  const childThemes = parentTheme.id ? themes.filter(theme => theme.parent_id === parentTheme.id) : [];
                                    
                                        return childThemes.length === 0 ? (
                                          <li
                                            key={parentTheme.id}
                                            style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px' }}
                                            // onClick={async () => {
                                            //   setActiveKeyTheme(null);
                                            //   setSelectedSubThemeId(parentTheme.id);
                                            //   setSearchParams(prevParams => {
                                            //     prevParams.delete('topic_id');
                                            //     if (parentTheme.id !== null) {
                                            //       prevParams.set('topic_id', parentTheme.id);
                                            //     }
                                            //     return prevParams;
                                            //   });
                                    
                                            //   try {
                                            //     if (isCards) {
                                            //       dispatch(fetchCardsListAction({ category_id: parentTheme.id }));
                                            //       handleClose();
                                            //       return;
                                            //     }

                                            //     if (segmentedParams === 'authors') {
                                            //       const authorList = await fetchAutorsList(null, parentTheme.id);
                                            //       setAuthors(authorList);
                                            //         onDataSubmit(authorList || []);
                                            //         handleClose();
                                            //     } else {
                                            //       const response = await fetchArticleList(null, null, parentTheme.id);
                                            //       setArticles(response?.list);
                                            //       onDataSubmit(response?.list || [], response?.total_count || 0);
                                            //         handleClose();
                                            //     }
                                            //   } catch (error) {
                                            //     console.error('Error fetching content:', error);
                                            //   }
                                            // }}
                                            onClick={() => {
                                              setActiveKeyTheme(null);
                                              setSelectedSubThemeId(parentTheme.id);
                                              setSearchParams(prevParams => {
                                                prevParams.delete('topic_id');
                                                if (parentTheme.id !== null) {
                                                  prevParams.set('topic_id', parentTheme.id);
                                                }
                                                return prevParams;
                                              });

                                              if (isCards) {
                                                dispatch(fetchCardsListAction({ category_id: parentTheme.id }));
                                                handleClose();
                                                return;
                                              }

                                              setPendingClose(true);
                                              if (segmentedParams === 'authors') {
                                                dispatch(fetchAutorsListAction({ fio: null, theme_id: parentTheme.id }));
                                              } else {
                                                dispatch(fetchArticleListAction({ theme_id: parentTheme.id }));
                                              }
                                            }}
                                          >
                                            <div style={{background: selectedSubThemeId === parentTheme.id ? "rgba(231, 250, 255, 1)" : '#fff' , borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9'}}>
                                            <MyText color={selectedSubThemeId === parentTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C'} size={18} weight={600}>
                                              {parentTheme.name}
                                            </MyText>
                                            </div>
                                            
                                          </li>
                                        ) : (
                                          <ThemeCollapse
                                            activeKey={activeKeyTheme}
                                            onChange={handlePanelChange}
                                            style={{ marginBottom: '8px', background: '#fff' }}
                                            key={parentTheme.id}
                                          >
                                            <Panel
                                              header={
                                                <MyText color="#0A033C" size={18} weight={600}>
                                                  {parentTheme.name}
                                                </MyText>
                                              }
                                              key={parentTheme.id}
                                            >
                                              <ul style={{ padding: 0, listStyleType: 'none' }}>
                                                {childThemes.map(subTheme => (
                                                  <li
                                                    key={subTheme.id}
                                                    style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px', color: selectedSubThemeId === subTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C' }}
                                                    // onClick={async () => {
                                                    //   setSelectedSubThemeId(subTheme.id);
                                                    //   setSearchParams(prevParams => {
                                                    //     prevParams.set('topic_id', subTheme.id);
                                                    //     return prevParams;
                                                    //   });
                                    
                                                    //   try {
                                                    //     if (isCards) {
                                                    //       dispatch(fetchCardsListAction({ category_id: parentTheme.id }));
                                                    //       handleClose();
                                                    //       return;
                                                    //     }
                                                    //     if (segmentedParams === 'authors') {
                                                    //       const authorList = await fetchAutorsList(null, subTheme.id);
                                                    //       setAuthors(authorList);
                                                    //       handleClose();
                                                    //     } else {
                                                    //       const response = await fetchArticleList(null, null, subTheme.id);
                                                    //       setArticles(response?.list);
                                                    //       onDataSubmit(response?.list || [], response?.total_count || 0);
                                                    //       handleClose();
                                                    //     }
                                                    //   } catch (error) {
                                                    //     console.error('Error fetching content:', error);
                                                    //   }
                                                    // }}
                                                    onClick={() => {
                                                      setSelectedSubThemeId(subTheme.id);
                                                      setSearchParams(prevParams => {
                                                        prevParams.set('topic_id', subTheme.id);
                                                        return prevParams;
                                                      });

                                                      if (isCards) {
                                                        dispatch(fetchCardsListAction({ category_id: parentTheme.id }));
                                                        handleClose();
                                                        return;
                                                      }

                                                      setPendingClose(true);
                                                      if (segmentedParams === 'authors') {
                                                        dispatch(fetchAutorsListAction({ fio: null, theme_id: subTheme.id }));
                                                      } else {
                                                        dispatch(fetchArticleListAction({ theme_id: subTheme.id }));
                                                      }
                                                    }}
                                                  >
                                                    {subTheme.name}
                                                  </li>
                                                ))}
                                              </ul>
                                            </Panel>
                                          </ThemeCollapse>
                                        );
                                      })}
                  </PageName>
        <Row justify="center">
        <StyledButton onClick={handleClose}>
        {t("close")}
        </StyledButton>
        </Row>
    </Modal>
  );
};
